import { ADMIN_ROLE_NAME, COLLABORATOR_ROLE_NAME } from "../constants/roles";

// NOTE: Literal keys rather than `string` — both clients type `t()` against
// their generated key union, so a widened return type is rejected at the call
// site.
export type TDefaultRoleNameKey =
  | "roles.defaultRoleAdmin"
  | "roles.defaultRoleCollaborator";

// NOTE: The two default roles are stored canonically in English ("Admin",
// "Collaborator"), so every client has to map them to a localized label while
// letting custom role names through untouched. Which names count as default,
// how they are normalized, and which i18n key each resolves to all live here so
// web and mobile cannot drift — the per-platform hooks are only the
// `useTranslation` wiring around this.
//
// Returns null — not the name — for a custom role, so the caller decides what to
// do with a name that has no translation rather than this helper silently
// claiming a key exists for it.
export const resolveDefaultRoleNameKey = (
  name: string,
): TDefaultRoleNameKey | null => {
  switch (name.trim().toLowerCase()) {
    case ADMIN_ROLE_NAME:
      return "roles.defaultRoleAdmin";
    case COLLABORATOR_ROLE_NAME:
      return "roles.defaultRoleCollaborator";
    default:
      return null;
  }
};
